/* Swipe guard (shopify-hub: npm run swipe:guard). Abel, 25 Oct 2026, on Zeero: "scrolling down sometimes scroll to the right
   instead... shouldve only been vertical". A row that scrolls sideways (a carousel built on overflow-x) takes any swipe that
   starts on it and is not perfectly vertical, so on a phone, scrolling the page down over a tall row moves the row instead.
   Rows at least MIN px tall become vertical-only for the browser (touch-action: pan-y), so a scroll down always moves the
   page; a clearly sideways swipe (1.5x more across than down) still moves the row, following the finger, and lands on the next
   card when the row snaps. Product photo galleries are guarded too: they sit at the top of every product page, where a
   scroll down starts, and a sideways swipe still turns the photo. Left alone: the full-screen zoom and menu drawers. A
   swipe Chrome would drop whole (it started more sideways than pan-y allows) moves the page from here. Loaded by one line in
   layout/theme.liquid; does nothing on a device without touch. */
(function () {
  if (window.__hubSwipeGuard || !('ontouchstart' in window)) return;
  window.__hubSwipeGuard = true;
  var MIN = 240;
  var SKIP = '.product-media-modal, menu-drawer, .menu-drawer';

  function isRow(el) {
    if (el.__hubSg || el.clientHeight < MIN || el.scrollWidth <= el.clientWidth + 2) return false;
    var cs = getComputedStyle(el);
    return /(auto|scroll)/.test(cs.overflowX) && cs.touchAction.indexOf('pan-y') < 0 && cs.touchAction !== 'none' && !el.closest(SKIP);
  }

  /* where the row can come to rest: every child's snap position, as scrollLeft values */
  function stops(el) {
    var out = [], box = el.getBoundingClientRect(), max = el.scrollWidth - el.clientWidth;
    var pad = parseFloat(getComputedStyle(el).scrollPaddingLeft) || 0;
    for (var i = 0; i < el.children.length; i++) {
      var c = el.children[i], a = getComputedStyle(c).scrollSnapAlign.split(' ').pop();
      if (a === 'none') continue;
      var r = c.getBoundingClientRect(), left = r.left - box.left + el.scrollLeft;
      var at = a === 'center' ? left + r.width / 2 - el.clientWidth / 2 : a === 'end' ? left + r.width - el.clientWidth : left - pad;
      out.push(Math.max(0, Math.min(max, Math.round(at))));
    }
    return out.sort(function (p, q) { return p - q; });
  }

  function nearest(s, x) {
    var b = s[0];
    for (var i = 1; i < s.length; i++) if (Math.abs(s[i] - x) < Math.abs(b - x)) b = s[i];
    return b;
  }

  function guard(el) {
    el.__hubSg = true;
    el.style.touchAction = 'pan-y pinch-zoom';
    var x0 = null, y0 = 0, left0 = 0, page0 = 0, axis = '', snap = '', lastX = 0, lastY = 0, lastT = 0, v = 0, vy = 0, moves = 0, manual = null, restore = 0;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = lastX = e.touches[0].clientX; y0 = lastY = e.touches[0].clientY; lastT = Date.now(); v = vy = 0;
      left0 = el.scrollLeft; page0 = window.scrollY; axis = ''; moves = 0; manual = null;
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (x0 === null || e.touches.length !== 1) return;
      var x = e.touches[0].clientX, y = e.touches[0].clientY, dx = x - x0, dy = y - y0, t = Date.now();
      if (!axis) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        axis = Math.abs(dx) > 1.5 * Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') {
          clearTimeout(restore);
          snap = el.style.scrollSnapType;
          el.style.scrollSnapType = 'none'; // snapping would fight the finger
          el.style.scrollBehavior = 'auto';
        }
      }
      if (axis === 'x') el.scrollLeft = left0 - dx;
      else {
        // a swipe that STARTED more sideways than pan-y allows is dropped whole by Chrome: the page would not move at all.
        // If the browser has not moved the page after a few moves, move it here (Safari pans the vertical part itself)
        if (manual === null && ++moves >= 3) manual = window.scrollY === page0;
        if (manual) window.scrollBy(0, lastY - y);
      }
      if (t > lastT) { v = (x - lastX) / (t - lastT); vy = (y - lastY) / (t - lastT); lastT = t; }
      lastX = x; lastY = y;
    }, { passive: true });
    function end(e) {
      if (axis === 'y' && manual && Math.abs(vy) > 0.2) window.scrollBy({ top: -vy * 300, behavior: 'smooth' }); // keep the flick
      if (axis === 'x') {
        var t = e.changedTouches && e.changedTouches[0], dx = (t ? t.clientX : lastX) - x0;
        el.style.scrollBehavior = '';
        var s = stops(el);
        if (s.length) {
          // a short drag goes back to where it was; otherwise the first resting place at or past where the finger left
          // the row, in the swipe's direction (one card for a flick, more for a long drag)
          var now = el.scrollLeft, target = nearest(s, left0), i;
          if (Math.abs(dx) >= 30 && dx < 0) { for (i = 0; i < s.length; i++) if (s[i] > left0 + 2) { target = s[i]; if (s[i] >= now - 2) break; } }
          else if (Math.abs(dx) >= 30) { for (i = s.length - 1; i >= 0; i--) if (s[i] < left0 - 2) { target = s[i]; if (s[i] <= now + 2) break; } }
          el.scrollTo({ left: target, behavior: 'smooth' });
        } else if (Math.abs(v) > 0.2) {
          el.scrollBy({ left: -v * 250, behavior: 'smooth' }); // a free row keeps a little of the flick
        }
        restore = setTimeout(function () { el.style.scrollSnapType = snap; }, 700);
      }
      x0 = null; axis = '';
    }
    el.addEventListener('touchend', end, { passive: true });
    el.addEventListener('touchcancel', end, { passive: true });
  }

  /* geometry first (cheap), styles only for boxes that are wider inside than out */
  function scan() {
    var all = document.body ? document.body.getElementsByTagName('*') : [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.scrollWidth > el.clientWidth + 2 && el.clientHeight >= MIN && isRow(el)) guard(el);
    }
  }
  /* rows can appear late (lazy sections, sliders that switch to scrolling on a phone): look again a few times, and on the
     first touch of a row nothing caught yet (that touch is the browser's; the next one is guarded) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', function () { scan(); setTimeout(scan, 1500); setTimeout(scan, 4000); });
  document.addEventListener('touchstart', function (e) {
    for (var el = e.target; el && el !== document.body && el.nodeType === 1; el = el.parentElement) if (isRow(el)) { guard(el); break; }
  }, { passive: true, capture: true });
})();
